import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { COMPLETION_CARD_CONTEXT_BINDINGS_OPTION_KEY }
  from "%/dynamic-component-editor/constants/completion-card-option-keys";

export default class CompletionCardContextBindings extends BaseOption {
  static defaultValue = {};

  static userInterfaceComponent = {
    label: "Completion card contexts",
    component: inspectorTools.COMPLETION_COMPONENTS,
    props: {},
  };
}

if (CompletionCardContextBindings.optionKey !== COMPLETION_CARD_CONTEXT_BINDINGS_OPTION_KEY) {
  throw new Error(
    `completion card context bindings key drift: the option class derives "${CompletionCardContextBindings.optionKey}" `
    + `but constants/completion-card-option-keys.js declares "${COMPLETION_CARD_CONTEXT_BINDINGS_OPTION_KEY}". `
    + "The compile gate and the builder read the constant, so the bindings would be written where neither looks.",
  );
}
